import { Component, Input, ViewEncapsulation } from '@angular/core';

/**
 * Layout + validation hint for form rows that are not a single outline control (e.g. checkbox
 * rows, spinner + select, or custom slots). For one `ion-input`, `ion-select`, or `ion-textarea`
 * per row, use {@link FormInputFieldComponent}, {@link FormSelectFieldComponent}, or
 * {@link FormTextareaFieldComponent} instead. Those expose `optional` (label suffix + not
 * required); placeholders stay **value hints** (same style as required fields), never “Optional”.
 */
@Component({
  selector: 'crowdctrl-form-field',
  standalone: true,
  templateUrl: './form-field.component.html',
  styleUrls: ['../form-control-hint.css', './form-field.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class FormFieldComponent {
  @Input() invalid = false;
  @Input() hint = '';
}
